export default {
    nutron_ensina: "Nutron Ensina",
    project_name: "Nutronbox",
    welcome_to: "Bienvenue chez"
}
